const createEnvironment = function (baseApi, authApi) {
  return {
    intervals: {
      logout: 3600, // 1 hour in seconds
    },
    api: {
      dashboard: `${baseApi}`,
      auth: `${authApi}`,
    },
    token: {
      auth: process.env.AUTH_TOKEN,
    },
    googleMaps: {
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    },
    googleOAuth: {
      clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    },
    turnstile: {
      siteKey: process.env.REACT_APP_TURNSTILE_SITEKEY || '',
    },
    marketplace: {
      url: 'https://test.market.edify.la',
    },
    isProduction: false,
    isDevelopment: true,
  };
};

export default createEnvironment;
